import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Blood Sugar — 20×20 lab group icon (Figma 834:60).
 * Layers: glucose-meter body + readout + drop indicator.
 */
const IconBloodSugar: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(8.318 4.784)">
        <path d="M1.66796 4.44442C2.60129 4.44367 3.33408 3.74467 3.33333 2.85575C3.33267 2.03037 1.66433 0 1.66433 0C1.66433 0 -0.000708107 1.96962 2.25938e-07 2.8585C0.000750226 3.74737 0.734625 4.44521 1.66796 4.44442Z" />
      </g>
      <g transform="translate(9.158 15.034)">
        <path d="M0.834 1.66667C1.29425 1.66629 1.66704 1.29287 1.66667 0.832625C1.66629 0.372416 1.29288 -0.000374717 0.832667 2.82668e-07C0.372417 0.000375283 -0.000374717 0.37375 2.82668e-07 0.834C0.000375283 1.29425 0.373792 1.66704 0.834 1.66667Z" />
      </g>
      <g transform="translate(4.148 1.698)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.24898 0.00750863C0.558609 0.00807113 -0.000566236 0.568175 4.30314e-07 1.25853L0.00852986 11.6752C0.00909652 12.3655 0.569192 12.9248 1.25957 12.9242L3.23873 12.9225C3.27019 12.9225 3.30098 12.9197 3.3309 12.9143C3.33494 12.9136 3.33894 12.9128 3.34294 12.912L3.34603 16.6725L8.34603 16.6684L8.34294 12.908C8.37657 12.9148 8.4114 12.9183 8.44707 12.9183L10.4262 12.9167C11.1166 12.9161 11.6758 12.356 11.6752 11.6656L11.6667 1.24898C11.6661 0.558621 11.106 -0.000566236 10.4157 4.30304e-07L1.24898 0.00750863ZM9.58365 1.66734L2.08365 1.67348L2.08982 9.17346L9.58982 9.16734L9.58365 1.66734ZM2.50773 10.6315C2.50753 10.4013 2.69394 10.2146 2.92407 10.2145L4.59065 10.2131C4.82078 10.2129 5.00748 10.3993 5.00765 10.6294C5.00786 10.8595 4.82148 11.0463 4.59136 11.0464L2.92473 11.0478C2.69461 11.048 2.5079 10.8616 2.50773 10.6315ZM7.09073 10.211C6.86061 10.2113 6.67419 10.3979 6.6744 10.628C6.67457 10.8582 6.86128 11.0446 7.0914 11.0444L8.75803 11.043C8.98815 11.0428 9.17453 10.8561 9.17432 10.626C9.17415 10.3959 8.98744 10.2095 8.75732 10.2097L7.09073 10.211ZM7.5089 12.0857L4.17557 12.0885L4.17865 15.8385L7.51198 15.8357L7.5089 12.0857Z"
        />
      </g>
    </IconBase>
  );
};

export default IconBloodSugar;
